var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullRelocationPack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3746 4H1.62497C1.27999 4 1 4.23472 1 4.52392L1.00031 12.3828H10.9995V4.52392C10.9995 4.23472 10.7196 4 10.3746 4Z",
    fill: "#0083FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9046 8.16599L18.9045 11.122C18.9672 11.2131 18.9992 11.3183 18.9992 11.4259V14.3819C18.9992 14.7083 18.7005 14.9731 18.3326 14.9731H11.6662C11.2982 14.9731 10.9995 14.7083 10.9995 14.3819V8.46987C10.9995 8.14352 11.2982 7.87866 11.6662 7.87866H16.3326C16.5673 7.87866 16.7846 7.98744 16.9046 8.16599ZM15.7488 8.89216H12.4987V11.9326H17.4987L15.7488 8.89216Z",
    fill: "#0083FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.0002 11.9326H11.9995V14.9731H1.49998C1.22385 14.9731 1 14.7462 1 14.4664L1.0002 11.9326Z",
    fill: "#0083FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4999 14.9732C16.4999 15.5329 16.0522 15.9867 15.5 15.9867C14.9477 15.9867 14.5 15.5329 14.5 14.9732C14.5 14.4135 14.9477 13.9597 15.5 13.9597C16.0522 13.9597 16.4999 14.4135 16.4999 14.9732Z",
    fill: "#EEF6FE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4999 17C14.3973 17 13.5 16.0906 13.5 14.973C13.5 13.8555 14.3973 12.946 15.4999 12.946C16.6025 12.946 17.4998 13.8555 17.4998 14.973C17.4998 16.0906 16.6025 17 15.4999 17ZM15.4999 14.2974C15.1333 14.2974 14.8333 14.6014 14.8333 14.973C14.8333 15.3446 15.1333 15.6487 15.4999 15.6487C15.8666 15.6487 16.1665 15.3446 16.1665 14.973C16.1665 14.6014 15.8666 14.2974 15.4999 14.2974Z",
    fill: "#0083FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49991 14.9732C6.49991 15.5329 6.05221 15.9867 5.49995 15.9867C4.9477 15.9867 4.5 15.5329 4.5 14.9732C4.5 14.4135 4.9477 13.9597 5.49995 13.9597C6.05221 13.9597 6.49991 14.4135 6.49991 14.9732Z",
    fill: "#EEF6FE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49991 17C4.39729 17 3.5 16.0906 3.5 14.973C3.5 13.8555 4.39729 12.946 5.49991 12.946C6.60253 12.946 7.49982 13.8555 7.49982 14.973C7.49982 16.0906 6.60253 17 5.49991 17ZM5.49991 14.2974C5.13193 14.2974 4.83327 14.6014 4.83327 14.973C4.83327 15.3446 5.13193 15.6487 5.49991 15.6487C5.86789 15.6487 6.16655 15.3446 6.16655 14.973C6.16655 14.6014 5.86789 14.2974 5.49991 14.2974Z",
    fill: "#0083FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullRelocationPack);
export default __webpack_public_path__ + "static/media/fullRelocationPack.b478adfa.svg";
export { ForwardRef as ReactComponent };